import React, { useState } from "react";
import tgt_logo from "../../assets/common/logo.png";
import "./login.scss";
import { Link } from "react-router-dom";
import usePost from "../../customHooks/usePost/UsePost";
import CustomToast from "../../atomic/customToast/CustomToast";

const Login = () => {
  const [formDataState, setFormDataState] = useState({});
  const post = usePost();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormDataState({ ...formDataState, [name]: value });
  };
  const onSuccess = (data) => {
    if(data.success == false){
      CustomToast({ type: "error", message: `invalid email or password` });
    }else{
    const storedData = JSON.stringify(data?.data);
    localStorage.setItem("local_data", storedData);
    window.location.href = "/";
    }
    
  };
  const onSubmit = async (e) => {
    e.preventDefault();
    await post.postData("login", formDataState, onSuccess);
  };
  return (
    <div className=" login d-flex flex-column justify-content-center text-center">
      <div className="logo">
        <img
          src={tgt_logo}
          alt="tgt Logo - Uploading"
          className="w-100 h-100"
        />
      </div>
      <h1 class="my-3 text-xl bold capitalize text-gray-900">
        Login to your account
      </h1>
      <p class="mb-4">
        Don't have an account?{" "}
        <Link class="" to="/signup">
          Sign Up Now!
        </Link>
      </p>
      <div className="card p-4">
        <form onSubmit={onSubmit}>
          <div>
            <label for="username">
              Username or Email <span class="text-danger">*</span>
            </label>
            <input
              required
              label="Username or Email"
              type="text"
              name="email"
              id="username"
              value={formDataState?.email}
              onChange={handleChange}
            />
          </div>
          <div>
            <label for="Password">
              Password <span class="text-danger">*</span>
            </label>
            <input
              required
              label="Password"
              type="password"
              name="password"
              id="Password"
              value={formDataState?.password}
              onChange={handleChange}
            />
          </div>
          <button className="btn btn-primary my-3 w-100" type="submit">
            Login
          </button>
        </form>
        <Link class="" to="/">
          Forgot your password?
        </Link>
      </div>
    </div>
  );
};

export default Login;
